import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPepperstone = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M20.9743 5.63882C17.0595 3.38878 8.90842 1.62057 4.59305 1.50595C0.276575 1.39133 -0.205259 2.9292 0.0584705 6.43001C0.323312 9.93193 1.3326 15.3957 3.56039 18.8854C5.78707 22.375 9.23112 23.8907 12.8822 22.6399C16.5321 21.388 20.3901 17.3698 22.4788 13.9947C24.5675 10.6219 24.8891 7.88886 20.9743 5.63882ZM13.3106 15.2544H10.5653V19.8201H7.77004V9.66263H10.5653V12.4579H13.3106V12.4502C14.4623 12.4301 15.3904 11.4921 15.3904 10.3359C15.3904 9.17969 14.4623 8.2405 13.3106 8.22158V8.21936H4.2748L5.29633 5.42405H13.3095C16.0291 5.42405 18.2346 7.62959 18.2346 10.3492C18.2358 13.07 16.0302 15.2544 13.3106 15.2544Z",
		fill: "#0064FA"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M13.3106 15.2544H10.5653V19.8201H7.77004V9.66263H10.5653V12.4579H13.3106V12.4502C14.4623 12.4301 15.3904 11.4921 15.3904 10.3359C15.3904 9.17969 14.4623 8.2405 13.3106 8.22158V8.21936H4.2748L5.29633 5.42405H13.3095C16.0291 5.42405 18.2346 7.62959 18.2346 10.3492C18.2358 13.07 16.0302 15.2544 13.3106 15.2544Z",
		fill: "white"
	})]
});
export default SvgPepperstone;
